module.exports = __webpack_public_path__ + "static/media/Collection_Block.8be5602c.svg";